export const summaryRows: string[] = [
  'Volume 01 — Underground Mine Fundamentals: Ore Bodies, Mine Layout, Access & Development',
  'Volume 02 — Underground Mining Methods: Room & Pillar, Stoping, Cut & Fill & Caving',
  'Volume 03 — Rock Mechanics & Ground Support: Geomechanics for Underground Mines',
  'Volume 04 — Drilling, Blasting & the Development Cycle',
  'Volume 05 — Ventilation, Drainage & Mine Services',
  'Volume 06 — Loading, Haulage, Hoisting & Underground Safety Operations',
  'Bonus 1 — Underground Mining Formulas & Calculations Quick-Reference',
  'Bonus 2 — Underground Shift Inspection & Pre-Start Checklists',
  'Bonus 3 — Ground Conditions Field Guide: Reading the Rock & Spotting Warning Signs',
  'Bonus 4 — How to Read Underground Mine Plans, Long Sections & Development Drawings',
  'Bonus 5 — Underground Mining Terminology Dictionary',
  '7-day money-back guarantee',
  'Instant access',
];
